// @flow

import styled from 'styled-components';

const RowIcon = styled.img`
  width: 32px;
  height: 32px;
  fill: #1cc982;
  align-self: flex-start;
  margin-top: 5px;
`;

export default RowIcon;
